export interface Workspace {
  uuid: string;
  name: string;
  label: string;
  owner: string;
  has_logo?: boolean;
  logo_version?: number;
}

export interface WorkspaceDetails {
  uuid: string;
  name: string;
  label: string;
  owner: string;
  datasource_count: number;
  model_count: number;
  postgres_size_bytes: number;
  elasticsearch_size_bytes: number;
  member_count: number;
  owner_email: string;
  most_recent_api_request: string | null;
  has_logo?: boolean;
  logo_version?: number;
}

// Splits workspaces into ones the user owns vs. everything else (shared or, for
// platform admins, all other platform workspaces).
export function partitionWorkspacesByOwnership<T extends { owner: string }>(
  workspaces: T[],
  userID: string | null,
): { mine: T[]; other: T[] } {
  const mine: T[] = [];
  const other: T[] = [];

  for (const workspace of workspaces || []) {
    if (userID && workspace.owner === userID) {
      mine.push(workspace);
    } else {
      other.push(workspace);
    }
  }

  return { mine, other };
}
